import IAPRewardsData from "@resource/data/rewards/IAPRewards.json";
import deprecatedIAPRewardsData from "@resource/data/rewards/deprecatedIAPRewards.json";
import MyFarmIAPRewardsData from "../../../../build/temp/FarmIAPRewards.json";
import { IAPReward } from "Utility/RewardHelper";

export function isIAPDeprecated(productId: string): boolean {
  return deprecatedIAPRewardsData.some((r) => r.id === productId);
}

/**
 * Get all currently available IAP rewards. This method concatenates various sources of IAP rewards:
 * - `IAPRewards.json` standard IAP configured with source code.
 * - `FarmIAPRewards.json` reward data for my-farm premium items generated at build-time from my-farm item bundles.
 * - TODO: Data from remote sources at runtime.
 */
export function getIAPRewards():IAPReward[] {
  return [
    ...IAPRewardsData,
    ...deprecatedIAPRewardsData,
    ...MyFarmIAPRewardsData,
  ] as IAPReward[]
}
